import { AppointmentsGetManyRequest } from '../../types'
import { logFactory } from '../../util'
import { useAppointmentsService } from '../services'
import { useQuery } from 'react-query'

const hookName = 'useAppointments'
const log = logFactory(hookName)

const useAppointments = (request: AppointmentsGetManyRequest, enabled = true) => {
  const { getAppointments, isReady } = useAppointmentsService()

  const doQuery = async () => {
    log(`📆 Fetching appointments...`, request)

    const results = await getAppointments(request)

    log(`📆 Returned appointments...`, results.data)

    return results.data
  }

  return useQuery([hookName, request], doQuery, {
    enabled: isReady && enabled,
  })
}

export { useAppointments, hookName }
